import { LanguageProvider } from './context/LanguageContext';
import './App.css';
import Hero from './components/Hero'; 

function App() {
  return (
    <LanguageProvider>
      <Hero />
    </LanguageProvider>
  );
}

export default App;
